import React from 'react'
import EventAgent from '@hotmart/event-agent-js'
import ResponsiveContextProvider from './src/contexts/responsiveContext'
import PageContainer from './src/layouts/PageContainer'
import Icons from './src/commons/icons'
import PageAlertContextProvider from './src/contexts/pageAlertContext'
import SideMenuContextProvider from './src/contexts/sideMenuContext'
import AuthContextProvider from './src/contexts/authContext'
import SearchContextProvider from './src/contexts/searchContext'
import { HotmartRum } from '@hot-observability-js/gatsby'

import './src/config/i18n'

import '@hotmart/cosmos/dist/styles/base.css'
import '@hotmart/cosmos/dist/styles/reset.css'
import '@hotmart/cosmos/dist/styles/theme.css'

import '@hotmart/cosmos/dist/alert/variations/success.css'
import '@hotmart/cosmos/dist/button/button.css'
import '@hotmart/cosmos/dist/form/input-default.css'
import '@hotmart/cosmos/dist/form/input-validate.css'
import '@hotmart/cosmos/dist/form/form.css'
import '@hotmart/cosmos/dist/grid/grid.css'

import '@hotmart/cosmos/dist/styles/utilities/border/border.css'
import '@hotmart/cosmos/dist/styles/utilities/display/display.css'
import '@hotmart/cosmos/dist/styles/utilities/flex/flex.css'
import '@hotmart/cosmos/dist/styles/utilities/scroll.css'
import '@hotmart/cosmos/dist/styles/utilities/sizing.css'
import '@hotmart/cosmos/dist/styles/utilities/spacing/spacing.css'
import '@hotmart/cosmos/dist/styles/utilities/text/text.css'
import './src/style.css'

import '@hotmart/cosmos/dist/avatar'
import '@hotmart/cosmos/dist/alert'
import '@hotmart/cosmos/dist/collapse'
import '@hotmart/cosmos/dist/dropdown'
import '@hotmart/cosmos/dist/header'
import '@hotmart/cosmos/dist/loading'
import '@hotmart/cosmos/dist/menu-item'
import '@hotmart/cosmos/dist/sidebar'
import '@hotmart/cosmos/dist/structure'
import '@hotmart/cosmos/dist/tag'
import '@hotmart/cosmos/dist/tag/variations/small.css'
import '@hotmart/cosmos/dist/tag/variations/blue.css'
import '@hotmart/cosmos/dist/toast'
import '@hotmart/cosmos/dist/tooltip'

Icons.init()
const env = process.env.GATSBY_ACTIVE_ENV
EventAgent.mode = env !== 'production' ? 'staging' : env

if (env !== 'development') {
  HotmartRum.init({
    dsn: process.env.SENTRY_DSN,
    release: `${process.env.GATSBY_PATH_PREFIX}@${new Date().toJSON().substring(0, 10)}`,
    environment: EventAgent.mode,
    disableCaptureConsoleIntegration: true,
  })
}

export const wrapPageElement = ({ element, props }) => {
  return (
    <>
      <HotmartRum.ErrorBoundary fallback={'Um erro ocorreu!'}>
        <hot-toast></hot-toast>
        <ResponsiveContextProvider>
          <PageAlertContextProvider>
            <AuthContextProvider>
              <SideMenuContextProvider>
                <SearchContextProvider>
                  <PageContainer {...props}>{element}</PageContainer>
                </SearchContextProvider>
              </SideMenuContextProvider>
            </AuthContextProvider>
          </PageAlertContextProvider>
        </ResponsiveContextProvider>
      </HotmartRum.ErrorBoundary>
    </>
  )
}
